import React, { MouseEventHandler, ReactElement } from 'react';
import { Immutable, safeRest } from '@wds/utils';
import { useHeaderTheme } from '../../theme';

import useStyles from './useStyles';

export type NavButtonProps = Immutable<{
  children: React.ReactNode;
  active?: boolean;
  href?: string;
  label: string;
  target?: string;
}> & {
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

const NavButton = ({
  children,
  active = false,
  href = undefined,
  label,
  target = undefined,
  onClick = () => {},
  ...rest
}: NavButtonProps): ReactElement => {
  const theme = useHeaderTheme();
  const classes = useStyles({ active, theme });

  const button = (
    <button
      type="button"
      aria-label={label}
      className={classes.navButton}
      onClick={onClick}
      {...safeRest(rest)}
    >
      {children}
    </button>
  );

  const link = (
    <a
      href={href}
      className={classes.navButton}
      title={label}
      target={target}
      {...safeRest(rest)}
    >
      {children}
    </a>
  );

  return href ? link : button;
};

export default NavButton;
export { NavButton };
